import type { IDoctor } from '@/entities/doctor/model/types';

export const getDoctorReviewsUrl = (doctor: IDoctor) => {
  return {
    pathname: `/${doctor.city.alias}/doctor/${doctor.alias}`,
    hash: 'review',
  };
};
